export const ApiSettings = {
    get: params => ({
        url: '/settings',
        method: 'GET',
        params
    })
};